import { buildProps, definePropType } from "@xplus/utils/props";
import { useSizeProp } from "@xplus/hooks";
import type { ExtractPropTypes, Component } from "vue";

export const ButtonIconProps = buildProps({
  icon: {
    type: definePropType<string | Component>([String, Object]),
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  size: useSizeProp,
} as const);

export type XButtonIconProps = ExtractPropTypes<typeof ButtonIconProps>;
